import { useState, useRef } from "react";
//import Footer from "./components/Footer";
//import Header from "./components/Header";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import SignatureCanvas from "react-signature-canvas";
import { Routes, Route, useNavigate } from "react-router-dom";
import ThankYou from "./pages/ThankYou";
import CheckIn from "./pages/CheckIn";
import Successful from "./pages/Successful";
import NotRegistered from "./pages/NotRegistered";


function App() {
  const navigate = useNavigate();
  const sigCanvas = useRef();
  const typeCanvas = useRef();

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    dob: "",
    address: "",
    email: "",
    phone: "",
    emergency_firstname: "",
    emergency_lastname: "",
    emergency_phone: "",
    activities: [],
    fitness_goals: [],
    health_condition: "no",
    health_condition_explanation: "",
    signatureMode: "draw", // draw o type
    signature: "",        // signature draw
    typedSignature: ""    // signature text
  });

  // HANDLE CHANGE
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  // HANDLE CHECKBOX
  const handleCheckbox = (e) => {
    const { name, value, checked } = e.target;

    if (checked) {
      setForm({
        ...form,
        [name]: [...form[name], value]
      });
    } else {
      setForm({
        ...form,
        [name]: form[name].filter((item) => item !== value)
      });
    }
  };



  // HANDLE SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();
// ACTIVITIES REQUIRED
if (form.activities.length === 0) {
  toast.error("Please select at least one activity", {
    position: "top-center",
    autoClose: 3000
  });
  return;
}

// FITNESS GOALS REQUIRED
if (form.fitness_goals.length === 0) {
  toast.error("Please select at least one fitness goal", {
    position: "top-center",
    autoClose: 3000
  });
  return;
}

    const payload = { ...form };

    try {
      const res = await //http://localhost:3003/api/register, {
      fetch("/api/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const data = await res.json();

      if (!data.success) {
        toast.error(data.message || "Registration failed.", {
          position: "top-center",
          autoClose: 3000
        });
        return;
      }


navigate("/thank-you");



      setForm({
        firstName: "",
        lastName: "",
        dob: "",
        address: "",
        email: "",
        phone: "",
        emergency_firstname: "",
        emergency_lastname: "",
        emergency_phone: "",
        activities: [],
        fitness_goals: [],
        health_condition: "no",
        health_condition_explanation: "",
        signature: "",
        typedSignature: ""
      });

      sigCanvas.current.clear();

    } catch (error) {
      toast.error("Server error. Try again.", {
        position: "top-center",
        autoClose: 3000
      });
    }
  };

  return (
    <Routes>
      <Route
      path="/"
      element={
<>
<div
  className="responsive-container"
  style={{
    marginTop: "10%",
    maxWidth: "600px",
    margin:"20px auto 0px",
    fontFamily:"Arial, sans-serif",
    display:"flex",
    flexDirection:"column",
    gap:"18px",
    padding:"30px",
    backgroundColor:"white",
    boxShadow:"rgba(0, 0, 0, 0.15) 0px 4px 12px",
    borderRadius:"20px"
  }}
>

  {/* <Header /> */}

     

      <form onSubmit={handleSubmit} className="register-form" style={{ display: "flex", flexDirection: "column", gap: "30px" }}>
{/* IMAGE ABOVE FIRST NAME */}
 <div style={{ textAlign: "center", marginBottom: "20px" }}> 
 <img 
  src="images/FITZONE.png" 
  alt="Form Header" 
  className="responsive-image"
  style={{ borderRadius: "8px" }} 
/>

  </div>
        {/* FIRST NAME */}
        <div>
          <label style={{ fontWeight: "bold" }}>First Name</label>
          <input
            name="firstName"
            value={form.firstName}
            onChange={handleChange}
            required
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc",
          
            }}
          />
        </div>

        {/* LAST NAME */}
        <div>
          <label style={{ fontWeight: "bold" }}>Last Name</label>
          <input
            name="lastName"
            value={form.lastName}
            onChange={handleChange}
            required
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc"
            }}
          />
        </div>

        {/* DOB */}
        <div>
          <label style={{ fontWeight: "bold" }}>Date of Birth</label>
          <input
            type="date"
            name="dob"
            value={form.dob}
            onChange={handleChange}
            required
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc"
            }}
          />
        </div>

        {/* ADDRESS */}
        <div>
          <label style={{ fontWeight: "bold" }}>Address</label>
          <input
            name="address"
            value={form.address}
            onChange={handleChange}
            required
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc"
            }}
          />
        </div>

        {/* EMAIL */}
        <div>
          <label style={{ fontWeight: "bold" }}>Email</label>
    <input
  type="email"
  name="email"
  value={form.email}
  onChange={handleChange}
  required
  pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
  placeholder="Enter your email"
  style={{
    width: "100%",
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc"
  }}
/>

        </div>

        {/* PHONE */}
        <div>
          <label style={{ fontWeight: "bold" }}>Phone Number</label>
          <input
            type="tel"
            name="phone"
            value={form.phone}
            onChange={handleChange}
            required
            pattern="[0-9]{10}"
            placeholder="Enter 10‑digit phone number (numbers only, no spaces or symbols)"
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc"
            }}
          />
        </div>

        {/* EMERGENCY CONTACT */}
        <div>
          <label style={{ fontWeight: "bold" }}>Emergency Contact First Name</label>
          <input
            name="emergency_firstname"
            value={form.emergency_firstname}
            onChange={handleChange}
            required
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc"
            }}
          />
        </div>

        <div>
          <label style={{ fontWeight: "bold" }}>Emergency Contact Last Name</label>
          <input
            name="emergency_lastname"
            value={form.emergency_lastname}
            onChange={handleChange}
            required
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc"
            }}
          />
        </div>

        <div>
          <label style={{ fontWeight: "bold" }}>Emergency Contact Phone</label>
          <input
            type="tel"
            name="emergency_phone"
            value={form.emergency_phone}
            onChange={handleChange}
            required
            pattern="[0-9]{10}"
            placeholder="Enter 10‑digit phone number (numbers only, no spaces or symbols)"
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc"
            }}
          />
        </div>

  {/* ACTIVITIES */}
<div style={{ marginBottom: "30px" }}>
  <label style={{ fontWeight: "bold" }}>Activities</label>

  {[
    { value: "FITZONE", label: "FITZONE (Beginners class - Tuesday/Thursday at 6:30 pm)" },
    { value: "FITZONE+", label: "FITZONE+ (High Intensity class - Monday/Wednesday at 6:00 pm)" },
    { value: "FITZONE SPIN", label: "FITZONE+ SPIN (Intermediate - Monday/Wednesday at 7:00 am)" },
    { value: "FITZONE-V", label: "FITZONE-V (Virtual Classes at your own pace)" },
    { value: "FITZONE RUN CLUB", label: "FITZONE RUN CLUB (Saturdays at 7:00 am)" }
  ].map((act) => (
    <label key={act.value} style={{ display: "block", marginTop: "8px" }}>
      <input
        type="checkbox"
        name="activities"
        value={act.value}
        onChange={handleCheckbox}
        checked={form.activities.includes(act.value)}
      />
      {" "}{act.label}
    </label>
  ))}
</div>




        {/* FITNESS GOALS */}
 <div style={{ marginBottom: "30px" }}>
  <label style={{ fontWeight: "bold" }}>Fitness Goals</label>

  {["Lose Weight", "Gain Muscle", "Improve Flexibility", "Increase Endurance"].map((goal) => (
    <label key={goal} style={{ display: "block", marginTop: "8px" }}>
      <input
        type="checkbox"
        name="fitness_goals"
        value={goal}
        onChange={handleCheckbox}
        checked={form.fitness_goals.includes(goal)}
      />
      {" "}{goal}
    </label>
  ))}
</div>


        {/* HEALTH CONDITION */}
        <div>
          <label style={{ fontWeight: "bold" }}>Health Condition</label>

          <label>
            <input
              type="radio"
              name="health_condition"
              value="yes"
              checked={form.health_condition === "yes"}
              onChange={handleChange}
            />
            Yes
          </label>

          <label>
            <input
              type="radio"
              name="health_condition"
              value="no"
              checked={form.health_condition === "no"}
              onChange={handleChange}
            />
            No
          </label>
        </div>

        {/* HEALTH CONDITION EXPLANATION */}
        {form.health_condition === "yes" && (
          <div>
            <label style={{ fontWeight: "bold" }}>Explain Health Condition</label>
            <textarea
              name="health_condition_explanation"
              value={form.health_condition_explanation}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #ccc"
              }}
            />
          </div>
        )}

     {/* SIGNATURE */}
<div>
  <label style={{ fontWeight: "bold" }}>Signature</label>

  {/* DRAW OR TYPE SELECTOR */}
  <div style={{ marginBottom: "10px", marginTop: "10px" }}>
    <label style={{ marginRight: "20px" }}>
      <input
        type="radio"
        name="signatureMode"
        value="draw"
        checked={form.signatureMode === "draw"}
        onChange={(e) => setForm({ ...form, signatureMode: e.target.value })}
      />
      Draw
    </label>

    <label>
      <input
        type="radio"
        name="signatureMode"
        value="type"
        checked={form.signatureMode === "type"}
        onChange={(e) => setForm({ ...form, signatureMode: e.target.value })}
      />
      Type
    </label>
  </div>

  {/* DRAW MODE */}
  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
  {form.signatureMode === "draw" && (
    <>
      <SignatureCanvas
        ref={sigCanvas}
        penColor="black"
        canvasProps={{
          width: 350,
          height: 150,
          className: "sigCanvas",
          style: {
            border: "1px solid #ccc",
            borderRadius: "6px",
            marginBottom: "10px"
          }
        }}
        onEnd={() => {
          setForm({
            ...form,
            signature: sigCanvas.current
              .getTrimmedCanvas()
              .toDataURL("image/png")
          });
        }}
      />

      <button
        type="button"
        onClick={() => {
          sigCanvas.current.clear();
          setForm({
            ...form,
            signature: "",
            typedSignature: ""
          });
        }}
        style={{
          marginBottom: "15px",
          padding: "6px 10px",
          background: "#ccc",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer"
        }}
      >
        Clear Signature
      </button>
    </>
  
  )}
  </div>
  {/* TYPE MODE */}
  {form.signatureMode === "type" && (
    <input
      type="text"
      placeholder="Type your full name"
      value={form.typedSignature}
      onChange={(e) => {
        const text = e.target.value;

        setForm({
          ...form,
          typedSignature: text
        });

        // Convert text to image using hidden canvas
        const canvas = typeCanvas.current;
        const ctx = canvas.getContext("2d");

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        ctx.font = "28px cursive";
        ctx.fillStyle = "black";
        ctx.textBaseline = "middle";

        const x = canvas.width / 2 - ctx.measureText(text).width / 2;
        const y = canvas.height / 2;

        ctx.fillText(text, x, y);

        setForm((prev) => ({
          ...prev,
          signature: canvas.toDataURL("image/png")
        }));
      }}
      style={{
        width: "100%",
        padding: "10px",
        borderRadius: "6px",
        border: "1px solid #ccc"
      }}
    />
  )}
</div>

{/* HIDDEN CANVAS FOR TYPE MODE */}
<canvas
  ref={typeCanvas}
  width={350}
  height={150}
  style={{ display: "none" }}
/>


        <button type="submit" className="register-btn">
          Register
        </button>
      </form>

      <ToastContainer />
      {/* <Footer /> */}
      
    </div>
    </>
      }
      />
<Route path="/thank-you" element={<ThankYou />} />
 <Route path="/checkin" element={<CheckIn />} />
 <Route path="/successful" element={<Successful />} />
 <Route path="/notregistered" element={<NotRegistered/>} />
 </Routes> 
);
}


export default App;
